import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Header = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('Username');
  const [isAdmin, setIsAdmin] = useState(false); // ✅ Track admin status

  useEffect(() => {
    const savedUsername = localStorage.getItem('origo_username');
    const adminId = localStorage.getItem('origo_admin_id'); // ✅ Check if admin token exists

    if (savedUsername) setUsername(savedUsername);
    if (adminId) setIsAdmin(true);
  }, []);

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('origo_access_token');
      if (token) {
        await axios.delete(
          `${process.env.REACT_APP_ORIGO_BASE_URL}oauth-jd/logout`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
    } catch (_) { /* ignore */ }

    localStorage.clear();
    navigate('/');
  };

  const getInitials = (name) => {
    if (!name) return '??';
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();
  };

  return (
    <div className="flex justify-between items-center px-10 py-4 border-b border-gray-200 dark:border-gray-700">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-[#9595E4] text-white flex items-center justify-center font-semibold">
          {getInitials(username)}
        </div>
        <h2 className="text-xl font-semibold text-[#1A1A1A] dark:text-white">
          Welcome {username}
        </h2>
      </div>

      <div className="flex items-center gap-4">
        {/* ✅ Show settings only if admin */}
        {isAdmin && (
          <button
            className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition"
            onClick={() => navigate('/admin')}
          >
            <img
              src="/images/settings.svg"
              alt="Settings"
              className="w-5 h-5"
            />
          </button>
        )}

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 hover:bg-blue-700 bg-[#2696F9] dark:bg-blue-600 text-white px-5 py-2 rounded-full text-sm font-medium transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 27 28" fill="none">
            <path
              d="M23.625 21.875C23.625 22.4938 23.4049 23.0232 22.9646 23.4635C22.5244 23.9037 21.9945 24.1243 21.375 24.125H5.625C5.00625 24.125 4.47675 23.9045 4.0365 23.4635C3.59625 23.0225 3.37575 22.493 3.375 21.875L3.375 15.125C3.375 14.8063 3.483 14.5389 3.699 14.3229C3.915 14.1069 4.182 13.9993 4.5 14C4.818 14.0008 5.08537 14.1088 5.30212 14.324C5.51888 14.5393 5.6265 14.8063 5.625 15.125V21.875H21.375V15.125C21.375 14.8063 21.483 14.5389 21.699 14.3229C21.915 14.1069 22.182 13.9993 22.5 14C22.818 14.0008 23.0854 14.1088 23.3021 14.324C23.5189 14.5393 23.6265 14.8063 23.625 15.125V21.875ZM14.625 8.17813L14.625 16.25C14.625 16.5688 14.517 16.8358 14.301 17.051C14.085 17.2663 13.818 17.3743 13.5 17.375C13.182 17.3758 12.915 17.2678 12.699 17.051C12.483 16.8343 12.375 16.5673 12.375 16.25L12.375 8.17813L10.2656 10.2875C10.0594 10.4938 9.80625 10.5969 9.50625 10.5969C9.20625 10.5969 8.94375 10.4938 8.71875 10.2875C8.49375 10.0813 8.37638 9.81875 8.36663 9.5C8.35688 9.18125 8.46488 8.90938 8.69063 8.68438L12.7125 4.6625C12.9375 4.4375 13.2 4.325 13.5 4.325C13.8 4.325 14.0625 4.4375 14.2875 4.6625L18.3094 8.68438C18.5344 8.90938 18.6424 9.17638 18.6334 9.48538C18.6244 9.79438 18.507 10.0618 18.2813 10.2875C18.0563 10.4938 17.7893 10.592 17.4803 10.5823C17.1713 10.5725 16.9133 10.4649 16.7063 10.2594L14.625 8.17813Z"
              fill="white"
            />
          </svg>
          Log Out
        </button>
      </div>
    </div>
  );
};

export default Header;
